module.exports = __webpack_public_path__ + "static/media/platforms-image.fbb00491.png";